export default "__VITE_ASSET__CKB1UOmg__"